// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"196b341e","703":"f12c98d5","787":"e96efcda"}[chunkId] + ".chunk.js";
};